<template>
  <header
    class="sans container-fluid"
    style="width: 100%; font-size: 11px; margin-top: 30px"
  >
    <div class="row">
      <div class="col-12" style="width: 100%">
        <div style="display: flex; justify-content: space-between">
          <div class="sub-color" style="width: 100%">
            <p>
              <img
                :src="headerImg"
                style="
                  margin-left: auto;
                  margin-right: auto;
                  width: auto;
                  height: 180px;
                "
              />
            </p>
          </div>
          <div
            class="main-color"
            style="
              width: 100%;
              text-align: right;
              display: flex;
              flex-direction: column;
              padding-top: 30px;
              font-size: 14px;
            "
          >
            <div class="main-color">Ottley Capital Livestock Pty Ltd</div>
            <div class="main-color">ABN 73 638 859 346</div>
            <div class="main-color">www.ottleycapital.com</div>
            <div class="main-color">4/1 Jones Avenue, Moree NSW 2400</div>
            <div class="main-color">admin@ottleycapital.com</div>
            <div class="main-color">P) 02 6750 9406</div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    headerImg: {
      type: String,
    },
  },
};
</script>

<style scoped>
html {
  -webkit-print-color-adjust: exact;
}
.sans {
  font-family: "Roboto", sans-serif !important;
}

.serif {
  font-family: Georgia, "Times New Roman", Times, serif;
}
.shippori {
  font-family: "Shippori Mincho" !important;
}
.main-color {
  color: #231f20;
}
</style>
